import type { ContentWrapperProps } from './ContentWrapper.types'
import cn from 'classnames'
import * as React from 'react'
import styles from './ContentWrapper.module.css'

export function ContentWrapper({ children, actionsPosition, className }: ContentWrapperProps) {
  return (
    <div
      className={cn(
        styles.contentWrapper,
        {
          [styles.contentWrapperRight]: actionsPosition === 'right',
          [styles.contentWrapperBottom]: actionsPosition === 'bottom',
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
